import { Injectable } from '@angular/core';
import { CommonService, UserConnectionService } from '@app/shared/services';
import { InviteService } from '@app/shared/services/invite/invite.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription, from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { RootStoreState } from '..';
import * as relationshipActions from './actions';
import * as loginSelectors from '../../root-store/login-store/login.selector';

@Injectable()
export class RelationshipStoreEffects {
  user;
  subscription = new Subscription();

  constructor(
    private userConnectionService: UserConnectionService,
    private actions$: Actions,
    private store$: Store<RootStoreState.State>,
    private commonService: CommonService,
    private inviteService: InviteService,
    private _store: Store
  ) {
    this.subscription.add(
      this._store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.user = result;
        }
      })
    );
  }

  relationshipObject = this.store$.select('Relationship');

  getAllRelationships$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<relationshipActions.AllRelationships>(relationshipActions.ActionTypes.ALL_RELATIONSHIPS),

      switchMap((action: any) => {
        return this.userConnectionService.getAllConnections({ impersonate_user_id: action.payload ? action.payload : '' }).pipe(
          map((data) => {
            if (data) {
              let result = [];
              let groupedData = this.groupBy(data, 'connection_status');
              let sortArrangement = ['approved', 'pending', 'invited'];

              sortArrangement.map((item) => {
                if (groupedData[item]) {
                  groupedData[item].forEach((x) => {
                    result.push(x);
                  });
                }
              });

              data.forEach((element) => {
                if (element['user_invite_status'] == 'sent' || element['user_invite_status'] == 'resent') {
                  result.push(element);
                }
              });

              if (result.length > 1) {
                result = result.reverse();
              }
              return new relationshipActions.AllRelationshipsComplete(result);
            }
          }),

          catchError((error) => {
            return of(new relationshipActions.AllRelationshipsFailure(error));
          })
        );
      })
    )
  );

  getClientRelationships$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<relationshipActions.impersonateUserRelationships>(relationshipActions.ActionTypes.IMPERSONATE_USER_RELATIONSHIPS),

      switchMap((action: any) => {
        return this.userConnectionService.getAllConnections({ impersonate_user_id: action.payload ? action.payload : '' }).pipe(
          map((data) => {
            if (data) {
              let result = [];
              let groupedData = this.groupBy(data, 'connection_status');
              let sortArrangement = ['approved', 'pending', 'invited'];

              sortArrangement.map((item) => {
                if (groupedData[item]) {
                  groupedData[item].forEach((x) => {
                    result.push(x);
                  });
                }
              });

              data.forEach((element) => {
                if (element['user_invite_status'] == 'sent' || element['user_invite_status'] == 'resent') {
                  result.push(element);
                }
              });

              if (result.length > 1) {
                result = result.reverse();
              }
              return new relationshipActions.impersonateUserRelationshipsComplete(result);
            }
          }),

          catchError((error) => {
            return of(new relationshipActions.impersonateUserRelationshipsFailure(error));
          })
        );
      })
    )
  );

  // @ts-ignore
  getAllInviteList$: Observable<any> = createEffect(() =>
    // @ts-ignore
    this.actions$.pipe(
      ofType<relationshipActions.AllInvites>(relationshipActions.ActionTypes.ALL_INVITELIST),
      switchMap((action: any) => {
        return this.inviteService.getInvites(this.user.id, null).pipe(
          map((data) => {
            return new relationshipActions.AllInvitesComplete(data);
          }),
          catchError((error) => {
            return of(new relationshipActions.AllInvitesFailure(error));
          })
        );
      })
    )
  );

  getAllClientGroups$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<relationshipActions.AllClientGroups>(relationshipActions.ActionTypes.ALL_CLIENT_GROUPS),

      switchMap((action: any) => {
        return this.commonService.getClientGroup().pipe(
          map((data) => {
            return new relationshipActions.AllClientGroupsComplete(data);
          }),
          catchError((error) => {
            return of(new relationshipActions.AllClientGroupsFailure(error));
          })
        );
      })
    )
  );
  getAllMySuggestion$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<relationshipActions.MySuggestions>(relationshipActions.ActionTypes.ALL_RELATIONSHIPS),
      switchMap(() =>
        from(this.userConnectionService.getMySuggestions()).pipe(
          map((data) => {
            return new relationshipActions.MySuggestionsComplete(data);
          }),
          catchError((error) => {
            return of(new relationshipActions.MySuggestionsFailure(error));
          })
        )
      )
    )
  );

  groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }
}
